import { createAsyncAtom } from '../../lib';

const subaccountsDropdownOpen = createAsyncAtom(async () => {
  return false;
});
export default subaccountsDropdownOpen;
